// 产品
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST'
export const GET_PRODUCT_ITEM = 'GET_PRODUCT_ITEM'
export const ADD_PRODUCT_ITEM = 'ADD_PRODUCT_ITEM'
export const UPDATE_PRODUCT_ITEM = 'UPDATE_PRODUCT_ITEM'
export const DELETE_PRODUCT_ITEM = 'DELETE_PRODUCT_ITEM'

// 凭据
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST'
export const SET_PRODUCT_ITEM = 'SET_PRODUCT_ITEM'
export const GET_PRODUCT_CRED_LIST = 'GET_PRODUCT_CRED_LIST'
export const SET_PRODUCT_CRED_LIST = 'SET_PRODUCT_CRED_LIST'
export const GET_PRODUCT_CRED_ITEM = 'GET_PRODUCT_CRED_ITEM'
export const SET_PRODUCT_CRED_ITEM = 'SET_PRODUCT_CRED_ITEM'
export const ADD_PRODUCT_CRED_ITEM = 'ADD_PRODUCT_CRED_ITEM'
export const UPDATE_PRODUCT_CRED_ITEM = 'UPDATE_PRODUCT_CRED_ITEM'
export const DELETE_PRODUCT_CRED_ITEM = 'DELETE_PRODUCT_CRED_ITEM'

// 应用
export const ADD_APP_ITEM = 'ADD_APP_ITEM'
export const COPY_APP_ITEM = 'COPY_APP_ITEM'
export const DELETE_APP_ITEM = 'DELETE_APP_ITEM'
